import Api from '../../api/index';
import idb from "../../idb/custom_fields";
import idb_custom_values from "../../idb_dexie/custom_values.js";
import idb_custom_fields from "../../idb_dexie/custom_fields.js";

const CustomField = {
	namespaced: true,
  state:{
    allCustomFields: null,
    oneCustomField: null,

    storing_custom_values: false,
    storing_custom_fields: false,

    createCustomFieldWasGood: null,
    createCustomFieldMessage: null,

    indexCustomFieldWasGood: null,
    indexCustomFieldMessage: null,
  },
  mutations:{
    setCustomFields(state, CustomFields){
      state.CustomFields = CustomFields //.data.map(o=>o.attributes)
      // idb.store_custom_fields(CustomFields);

    },
    pushNewCustomField(state, CustomField){
      state.CustomFields.push(CustomField) //.data.attributes)
    },

    setOneCustomField(state, CustomField) {
      state.oneCustomField = CustomField
    },

    setStored(state, {data, value}){
      state[data] = value
    },

    setOfflineCustomFields(state){
      if (state.allCustomFields == null || !state.allCustomFields.length) {
        idb_custom_fields.getAllCustomFields().then((CustomFields) => {
          // console.log("HEY CF: ", CustomFields)
          state.allCustomFields = [...CustomFields];
        });
      }
    },

    clearOneCustomField(state){
      state.oneCustomField = null
    },

    
  },
  actions: {
    clearOneCustomField(context){
      context.commit('clearOneCustomField')
    },

    getOneCustomField(){

    },

    index(context){
      // context.commit("setOfflineCustomFields");
      // return true
      context.commit('setStored', {data: 'storing_custom_fields', value: true})
      context.commit('setStored', {data: 'storing_custom_values', value: true})

      return Api.CustomField.index({with_cv: true}).then(response => response.data).then(CustomFields => {
        CustomFields = CustomFields.data? CustomFields.data.map(cf=>cf.attributes) : CustomFields
        let custom_values_arr = []
        CustomFields = CustomFields.map(cf => {
          let {custom_values, ...c} = cf
          custom_values_arr = [...custom_values_arr, ...custom_values]
          return {...c}
        })
        context.commit('setCustomFields', CustomFields);

        // console.log({CustomFields});
        // console.log({custom_values_arr});
        
        // idb.store_custom_fields(CustomFields);
        // ! REMOVER EM ALGUNS DIAS
        idb.clear_custom_fields()
        
        context.commit('setStored', {data: 'storing_custom_values', value: true})
        idb_custom_values.addManyCustomValues(custom_values_arr).then(()=>{
          context.commit('setStored', {data: 'storing_custom_values', value: false})
          // console.log('salvou custom values');
        })

        context.commit('setStored', {data: 'storing_custom_fields', value: true})
        idb_custom_fields.addManyCustomFields(CustomFields).then(()=>{
          context.commit('setStored', {data: 'storing_custom_fields', value: false})
          // console.log('salvou custom fieldsss');
        })

        return CustomFields
      }).catch(function(error) {
        context.commit("setOfflineCustomFields");
      });
    },
    async indexV2(context){

      context.commit('setStored', {data: 'storing_custom_fields', value: true})
      context.commit('setStored', {data: 'storing_custom_values', value: true})

      let last_cv = await idb_custom_fields.getLastUpdatedCustomField()
      last_cv = last_cv[0]
      const last_updated_at = last_cv? last_cv.updated_at : null
      // console.log({last_cv, last_updated_at});

      return Api.CustomField.indexV2({with_cv: true, last_updated_at}).then(response => response.data).then(CustomFields => {
        CustomFields = CustomFields.data? CustomFields.data.map(cf=>cf.attributes) : CustomFields
        let custom_values_arr = []
        CustomFields = CustomFields.map(cf => {
          let {custom_values, ...c} = cf
          custom_values_arr = [...custom_values_arr, ...custom_values]
          return {...c}
        })
        context.commit('setCustomFields', CustomFields);

        context.commit('setStored', {data: 'storing_custom_values', value: true})
        idb_custom_values.addManyCustomValues(custom_values_arr).then(()=>{
          context.commit('setStored', {data: 'storing_custom_values', value: false})
        })

        context.commit('setStored', {data: 'storing_custom_fields', value: true})
        idb_custom_fields.addManyCustomFields(CustomFields).then(()=>{
          context.commit('setStored', {data: 'storing_custom_fields', value: false})
        })

        return CustomFields
      }).catch(function(error) {
        context.commit("setOfflineCustomFields");
      });
    },

    show(context, id){
      return Api.CustomField.show(id)
        .then(response => response.data)
        .then(CustomField => {
          CustomField = CustomField.data? CustomField.data.attributes : CustomField
          context.commit('setOneCustomField', CustomField);
          return CustomField
        }).catch(function(error) {
          console.log(error);
            // auto-comment// console.log(error);
        });
    },

    create(context, CustomField){
      return Api.CustomField.create(CustomField)
      .then(response => response.data)
      .then(CustomField => {
        context.commit('pushNewCustomField', CustomField);
        return CustomField
        }).catch(function(error) {
             // auto-comment// console.log(error);
        });
    }
  }
}

export default CustomField
